// @flow
import React, { PureComponent } from 'react';
import { StyleSheet, View, Platform } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import OrdersComponent from '../Dashboard/components/Orders';
import theme from '../../theme-config';

export default class Orders extends PureComponent<{}> {
  styles = getStyles();

  render() {
    const styles = this.styles;
    const edgesByOs = Platform.OS === 'android' ? ['bottom', 'left', 'right'] : ['bottom', 'left', 'right']
    return (
        <SafeAreaView style={styles.container} edges={edgesByOs}>
          <OrdersComponent />
        </SafeAreaView>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    safeareaview: {
      flex: 1,
      backgroundColor: theme.dashboardBackgroundColor,
    },
    container: {
      flex: 1,
      backgroundColor: theme.dashboardBackgroundColor,
      paddingTop: 8,
      paddingHorizontal: 8,
    },
  });
